import { Button, Divider, Grid, InlineStack, Select, Text, BlockStack, Banner, Badge } from '@shopify/polaris'
import { Carousel } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { DI, DIProps } from '../../../../Core';
import noImage from '../../../../../public/files/noImage.png';
interface props extends DIProps {
    previewModalData: any
    variantsArr: any
    getPreview: (val: string) => void
    selectedVariant: string
    setSelectedVariant: (val: string) => void
}

const AmazonPreview = (props: props) => {
    const { previewModalData, variantsArr, getPreview, selectedVariant, setSelectedVariant } = props;
    const { mandatory_attr, optional_attr } = previewModalData;
    const carouselRef:any = useRef(null);
    const [imageUrl, setImageUrl] = useState<any>([])
    const [general_attr, setGeneralAttr] = useState<any>({});
    const [expanded, setExpanded] = useState<any>({
        general_attr: false,
        description: false,
        optional_attr: false
    })

    useEffect(() => {
        let tempArr: any = [];
        let tempGeneralAttr: any = {};
        const { mandatory_attr, optional_attr, offerId } = previewModalData;

        Object.keys(mandatory_attr)?.forEach((key: string) => {
            if (key === 'main_image_url') {
                tempArr?.push(mandatory_attr?.main_image_url);
            }
            if (key?.includes('other_image_url')) {
                tempArr?.push(mandatory_attr?.[key]);
            }
        })
        Object.keys(mandatory_attr).forEach((key: string) => {
            if (key !== "item_name" && key !== "standard_price" && key !== "main_image_url" && key !== 'product_description' && !key?.includes("other_image_url")) {
                tempGeneralAttr[key] = mandatory_attr[key]
            }
        })
        if (offerId) {
            setSelectedVariant(offerId)
        }
        tempArr.uniqueArray()
        setImageUrl([...tempArr]);
        setGeneralAttr({ ...tempGeneralAttr });
    }, [previewModalData])

    const handleExpanded = (key: string) => {
        setExpanded({ ...expanded, [key]: !expanded[key] })
    }

    const contentStyle: any = {
        carouselProps: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            draggable: true,
            infinite: true,
            customPaging: function (i: any) {
                return (
                    <a>
                        <img onMouseEnter={()=>hoverChange(i)} src={imageUrl[i]} style={{ width: '100%', borderRadius: '4px', height: '40px', objectFit: 'fill' }} />
                    </a>
                );
            },
        },
    };
    const hoverChange =(index:number)=>{
        if(carouselRef) carouselRef?.current?.goTo(index);
    }

    return (
        <BlockStack gap='300' align='start'>
            <Grid columns={{ xs: 1, sm: 1, md: 5, lg: 5, xl: 5 }}>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}>
                    <BlockStack gap='200'>
                        {
                            variantsArr?.length > 0 &&
                            <Select
                                label='Select Variant'
                                options={[...variantsArr]}
                                placeholder='Select Variant'
                                value={selectedVariant}
                                onChange={(val: string) => {
                                    setSelectedVariant(val)
                                    getPreview(val)
                                }}
                            />
                        }
                        {
                            imageUrl?.length > 0 && imageUrl?.length > 1 ?
                                <div className='Custom__Carousel--Product'>
                                    <Carousel autoplay ref={carouselRef} {...contentStyle.carouselProps} >
                                        {Object.values(imageUrl)?.map((image: any, idx: number) =>
                                        (
                                            <div key={idx} >
                                                <img src={image} alt="product-image" style={{ width: "100%", height: '300px', objectFit: 'scale-down' }} />
                                            </div>
                                        )
                                        )}
                                    </Carousel>
                                </div>
                                :
                                <div >
                                    <img src={imageUrl[0] || noImage} alt="product-image" style={{ width: "100%", height: '300px', objectFit: 'scale-down' }} />
                                </div>
                        }
                    </BlockStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }}>
                    <BlockStack gap="500">
                        <Text variant="headingSm" as="h6">
                            Product Details
                        </Text>
                        <BlockStack gap="200">
                            <InlineStack gap='200' align='start' blockAlign='center'>
                                {
                                    mandatory_attr?.item_name &&
                                    <Text variant="headingLg" as="h5">
                                        {mandatory_attr?.item_name || ""}
                                    </Text>
                                }
                                {
                                    general_attr['category'] &&
                                        general_attr['category']?.toLowerCase() === 'default' &&
                                        general_attr['sub_category'] &&
                                        general_attr['sub_category']?.toLowerCase() === 'default' ?
                                        <Badge tone='info'>Offer Listing</Badge>
                                        :
                                        <Badge tone='success'>New listing</Badge>
                                }
                            </InlineStack>
                            <InlineStack gap="200">
                                {
                                    mandatory_attr?.standard_price !== undefined &&
                                        mandatory_attr?.standard_price !== "" ?
                                        <Text as="span" tone='subdued'>
                                            Price: {mandatory_attr?.standard_price?.toString() || "N/A"}
                                        </Text>
                                        :
                                        <Text as='p' tone='subdued'>Price: N/A</Text>
                                }
                            </InlineStack>
                            <Divider />
                            <Text variant="bodySm" as="span" tone='subdued' fontWeight='medium'>
                                GENERAL
                            </Text>
                            <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}>
                                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                                    <BlockStack gap="200">
                                        {
                                            Object.keys(general_attr).slice(0, expanded?.general_attr ? Object.keys(general_attr).length / 2 : 3).map((key: string, idx: number) => {
                                                return (
                                                    <InlineStack gap="100" key={idx}>
                                                        <span style={{ textTransform: 'capitalize' }}>
                                                            <Text as="span" fontWeight='medium' breakWord>
                                                                {key.split("_").join(' ')}:
                                                            </Text>
                                                        </span>
                                                        <Text as="span" breakWord>
                                                            {general_attr[key]?.toString() || "N/A"}
                                                        </Text>
                                                    </InlineStack>
                                                )
                                            })
                                        }
                                    </BlockStack>
                                </Grid.Cell>
                                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                                    <BlockStack gap="200">
                                        {
                                            Object.keys(general_attr).slice(Object.keys(general_attr).length / 2, expanded?.general_attr ? Object.keys(general_attr).length : Object.keys(general_attr).length / 2 + 3).map((key: string, idx: number) => {
                                                return (
                                                    <InlineStack gap="100" key={idx}>
                                                        <span style={{ textTransform: 'capitalize' }}>
                                                            <Text as="span" fontWeight='medium' breakWord>
                                                                {key.split("_").join(' ')}:
                                                            </Text>
                                                        </span>
                                                        <Text as="span" breakWord>
                                                            {general_attr[key]?.toString() || "N/A"}
                                                        </Text>
                                                    </InlineStack>
                                                )
                                            })
                                        }
                                    </BlockStack>
                                </Grid.Cell>
                            </Grid>
                            {
                                Object.keys(general_attr).length > 6 &&
                                <InlineStack align='end'>
                                    <Button
                                        variant='plain'
                                        disclosure={expanded?.general_attr ? 'up' : 'down'}
                                        onClick={() => {
                                            handleExpanded('general_attr')
                                        }}
                                    >
                                        {expanded?.general_attr ? 'Show less' : 'Show more'}
                                    </Button>
                                </InlineStack>
                            }
                            <Divider />
                            <Text variant="bodySm" as="span" tone='subdued' fontWeight='medium'>
                                DESCRIPTION
                            </Text>
                            {
                                mandatory_attr?.product_description &&
                                    mandatory_attr?.product_description !== "" ?
                                    !expanded?.description ?
                                        mandatory_attr?.product_description?.length > 80 ?
                                            <div dangerouslySetInnerHTML={{ __html: mandatory_attr?.product_description?.slice(0, 80) + "..." }}></div>
                                            :
                                            <div dangerouslySetInnerHTML={{ __html: mandatory_attr?.product_description }}></div>
                                        :
                                        <div dangerouslySetInnerHTML={{ __html: mandatory_attr?.product_description }}></div>
                                    :
                                    <Text as='p'>N/A</Text>
                            }
                            {
                                mandatory_attr?.product_description?.length > 80 &&
                                <InlineStack align='end'>
                                    <Button
                                        variant='plain'
                                        disclosure={expanded?.description ? 'up' : 'down'}
                                        onClick={() => {
                                            handleExpanded('description')
                                        }}
                                    >
                                        {expanded?.description ? 'Show less' : 'Show more'}
                                    </Button>
                                </InlineStack>
                            }
                            <Divider />
                            <Text variant="bodySm" as="span" tone='subdued' fontWeight='medium'>
                                ATTRIBUTES
                            </Text>
                            <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}>
                                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                                    <BlockStack gap="200">
                                        {
                                            Object.keys(optional_attr).slice(0, expanded?.optional_attr ? Object.keys(optional_attr).length / 2 : 3).map((key: string, idx: number) => {
                                                return (
                                                    <InlineStack gap="100" key={idx}>
                                                        <span style={{ textTransform: 'capitalize' }}>
                                                            <Text as="span" fontWeight='medium' breakWord>
                                                                {key.split("_").join(' ')}:
                                                            </Text>
                                                        </span>
                                                        <Text as="span" breakWord>
                                                            {optional_attr[key]?.toString() || "N/A"}
                                                        </Text>
                                                    </InlineStack>
                                                )
                                            })
                                        }
                                    </BlockStack>
                                </Grid.Cell>
                                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                                    <BlockStack gap="200">
                                        {
                                            Object.keys(optional_attr).slice(Object.keys(optional_attr).length / 2, expanded?.optional_attr ? Object.keys(optional_attr).length : Object.keys(optional_attr).length / 2 + 3).map((key: string, idx: number) => {
                                                return (
                                                    <InlineStack gap="100" key={idx} >
                                                        <span style={{ textTransform: 'capitalize' }}>
                                                            <Text as="span" fontWeight='medium' breakWord>
                                                                {key.split("_").join(' ')}:
                                                            </Text>
                                                        </span>
                                                        <Text as="span" breakWord>
                                                            {optional_attr[key]?.toString() || "N/A"}
                                                        </Text>
                                                    </InlineStack>
                                                )
                                            })
                                        }
                                    </BlockStack>
                                </Grid.Cell>
                            </Grid>
                            {
                                Object.keys(optional_attr).length > 6 &&
                                <InlineStack align='end'>
                                    <Button
                                        variant='plain'
                                        disclosure={expanded?.optional_attr ? 'up' : 'down'}
                                        onClick={() => {
                                            handleExpanded('optional_attr');
                                        }}
                                    >
                                        {expanded?.optional_attr ? 'Show less' : 'Show more'}
                                    </Button>
                                </InlineStack>
                            }
                        </BlockStack>
                    </BlockStack>
                </Grid.Cell>
            </Grid>
        </BlockStack>
    )
}

export default DI(AmazonPreview)